import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  constructor(private http: HttpClient) {}

  getAllTenants(): Observable<any[]> {
    // Asegúrate de definir api_service_tenant en tu environment
    return this.http.get<any[]>(`${environment.api_service_tenant}`);
  }
}